var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spirit-wrapper"},[_c('iframe',{staticClass:"spirit-frame",attrs:{"title":"Spirit PDF as HTML","src":"/spirit.html","loading":"lazy"}})])
}]

export { render, staticRenderFns }